<template>
<v-layout grid-list-md text-xs-center>
  <v-layout row wrap justify-center align-center fill-height v-if="show">
    <v-flex xs12>
      <v-progress-linear indeterminate></v-progress-linear>

    </v-flex>

  </v-layout>
  <v-layout row wrap v-if="!show">

    <v-flex xs12 mx-2 my-1>
      <v-card color="#efefef" dark>
        <v-card-title>
          <v-icon left color="grey">
            person
          </v-icon>
          <span class="grey--text font-weight-light">Hefe Jones</span>
        </v-card-title>

        <v-layout row pa-3>
          <v-flex xs9>

            <div>
              <div class="grey--text" style="text-align:left;"><b>Boss Card</b></div>
              <div class="grey--text" style="text-align:left;line-height:1.2;">Something</div>

            </div>

          </v-flex>
          <v-flex xs3>
            <div style="text-align:right;font-weight:400;" class="grey--text">xxxxx</div>
            <div style="text-align:right;" class="grey--text caption">xxxxx</div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <v-flex xs12 mx-2 my-1>
      <v-card color="#efefef" dark>
        <v-card-title>
          <v-icon left color="grey">
            person
          </v-icon>
          <span class="grey--text font-weight-light">Hefe Jones</span>
        </v-card-title>

        <v-layout row pa-3>
          <v-flex xs9>

            <div>
              <div class="grey--text" style="text-align:left;"><b>Boss Card</b></div>
              <div class="grey--text" style="text-align:left;line-height:1.2;">Something</div>

            </div>

          </v-flex>
          <v-flex xs3>
            <div style="text-align:right;font-weight:400;" class="grey--text">xxxxx</div>
            <div style="text-align:right;" class="grey--text caption">xxxxx</div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <v-flex xs12 mx-2 my-1>
      <v-card color="#efefef" dark>
        <v-card-title>
          <v-icon left color="grey">
            person
          </v-icon>
          <span class="grey--text font-weight-light">Hefe Jones</span>
        </v-card-title>

        <v-layout row pa-3>
          <v-flex xs9>

            <div>
              <div class="grey--text" style="text-align:left;"><b>Boss Card</b></div>
              <div class="grey--text" style="text-align:left;line-height:1.2;">Something</div>

            </div>

          </v-flex>
          <v-flex xs3>
            <div style="text-align:right;font-weight:400;" class="grey--text">xxxxx</div>
            <div style="text-align:right;" class="grey--text caption">xxxxx</div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <v-flex xs12 mx-2 my-1>
      <v-card color="#efefef" dark>
        <v-card-title>
          <v-icon left color="grey">
            person
          </v-icon>
          <span class="grey--text font-weight-light">Hefe Jones</span>
        </v-card-title>

        <v-layout row pa-3>
          <v-flex xs9>

            <div>
              <div class="grey--text" style="text-align:left;"><b>Boss Card</b></div>
              <div class="grey--text" style="text-align:left;line-height:1.2;">Something</div>

            </div>

          </v-flex>
          <v-flex xs3>
            <div style="text-align:right;font-weight:400;" class="grey--text">xxxxx</div>
            <div style="text-align:right;" class="grey--text caption">xxxxx</div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

  </v-layout>

</v-layout>
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'

export default {

  data () {
    return {
      post: {
        content: ''
      },
      comment: {
        postId: '',
        userId: '',
        content: '',
        postComments: 0
      },
      showCommentModal: false,
      showPostModal: false,
      fullPost: {},
      postComments: [],
      show: false
    }
  },

  computed: {
    ...mapState(['userProfile', 'currentUser'])

  },
  methods: {

  },
  watch: {
    userProfile () {
      this.show = this.userProfile.firstEntry
    }
  },
  filters: {
    formatDate (val) {
      if (!val) {
        return '-'
      }
      let date = val.toDate()
      return moment(date).fromNow()
    },
    trimLength (val) {
      if (val.length < 200) {
        return val
      }
      return `${val.substring(0, 200)}...`
    }
  }
}
</script>
